// extracted by mini-css-extract-plugin
export default {"authBtn":"AuthNav_authBtn__Yroom","contained":"AuthNav_contained__2gwxe","text":"AuthNav_text__zT6+r","registerBtn":"AuthNav_registerBtn__bOEfn"};